import { handleActions } from 'redux-actions';

import { claimQuickUpdate, claimQuickUpdateSuccess, claimQuickUpdateError } from './action';

export interface ClaimEditModalState {
  isUpdating: boolean;
  lastSuccessClaimableId: number | null;
  lastErrorClaimableId: number | null;
}

const initialState: ClaimEditModalState = {
  isUpdating: false,
  lastSuccessClaimableId: null,
  lastErrorClaimableId: null,
};

const reducer = handleActions<ClaimEditModalState>(
  {
    [String(claimQuickUpdate)]: (state) => ({
      ...state,
      isUpdating: true,
      lastSuccessClaimableId: null,
      lastErrorClaimableId: null,
    }),
    [String(claimQuickUpdateSuccess)]: (state, { payload }) => ({
      ...state,
      isUpdating: false,
      lastSuccessClaimableId: (payload as { claimableId: number }).claimableId,
      lastErrorClaimableId: null,
    }),
    [String(claimQuickUpdateError)]: (state, { payload }) => ({
      ...state,
      isUpdating: false,
      lastSuccessClaimableId: null,
      lastErrorClaimableId: (payload as { claimableId: number }).claimableId,
    }),
  },
  initialState,
);

export default reducer;
